import { whooshPrimitives } from "@whoosh/design-system/src/theme/colors";

export const getPatronMasqueradeBackgroundByEnv = (
  deployEnv?: string
): string => {
  switch (deployEnv) {
    case "prod":
      return "#B84242";
    case "replica":
      return "#E56C43";
    case "staging":
      return "#EBC500";
    case "demo":
      return "#5849B8";
    case "review":
      return "#2562B8";
    default:
      return whooshPrimitives.status.success[800];
  }
};
